
/* global angular */

/**
 * @doc module
 * @id GcECD
 * @description GcECD
 *
 */

angular.module('service.GcECD', ['pascalprecht.translate'])

/**
 * @doc service
 * @id GcECD:GcECD
 *
 * @description
 */
.factory('GcECD', [
'$rootScope',
'$translate',
'$log',
'CommentService',
'LocalStorageService',
function($rootScope, $translate, $log, CommentService, LocalStorageService) {
  'use strict';

  var GcECD = {
    ecd_editorial_mode: LocalStorageService.getItem('ecd_mode') || false
  };

  $rootScope.$on('logged_in', function(event, user) {
    if (user.role !== 'admin') GcECD.ecd_editorial_mode = false;
  });

  $rootScope.$on('logged_out', function() {
    GcECD.ecd_editorial_mode = false;
    GcECD.switchEditorialMode(false);
    GcECD.cancelECD();
  });

  GcECD.toggleEditorialMode = function() {
    this.switchEditorialMode(!this.ecd_editorial_mode);
  };

  /*
   * The user has can_promote rights and clicked on the Editorialize button
   */
  GcECD.switchEditorialMode = function(mode) {
    this.ecd_editorial_mode = mode;
    LocalStorageService.setItem('ecd_mode', this.ecd_editorial_mode);
    if (!this.ecd_editorial_mode) GcECD.cancelECD();
  };

  // The editor clicked on a thread to "editorialize" the thread
  GcECD.editorialMode = function(comment) {
    if (!$rootScope.ecd_creation_mode) {
      $rootScope.$broadcast('editorial', {
        activate : true,
        comment : comment
      });
    }
    else {
      $rootScope.$broadcast('editorial', {
        activate : false,
        comment : comment
      });
    }
    $rootScope.ecd_creation_mode = !$rootScope.ecd_creation_mode;
  };

  // The editor validates the editorialization
  GcECD.validateECD = function() {
    // The user didn't select any comment
    if (CommentService.getSelectedECD().length === 0) {
      return ;
    }

    var selected = angular.copy(CommentService.getSelectedECD());

    selected.forEach(function(cmt) {
      cmt.active = false;
      cmt.child_comments = [];
      cmt.parent_id = null;
    });

    CommentService.ecd.push({
      new_mode : true,
      comments : selected,
      title : ''
    });

    mixpanel.track('ecd:added');
    $rootScope.$emit("scrollTo", ".gc-body");
    CommentService.cancelSelectedECD();
  };

  // The editor cancels the editorialization
  GcECD.cancelECD = function() {
    $rootScope.$broadcast('editorial', {
      activate : false
    });
    $rootScope.ecd_creation_mode = false;

    // Cancel selected state on all comments
    CommentService.cancelSelectedECD();
  };

  // In the Editor's choice section, the editor clicked on the Edit button
  GcECD.editECD = function(event, ecd) {
    event.stopPropagation();

    ecd.edit_mode = true;
    ecd.old_title = ecd.title;
  };

  GcECD.onKeypress = function(event, ecd) {
    if (event.keyCode === 13 && ecd.title && ecd.title.length > 2) GcECD.saveECD(ecd);
  };

  // In the Editor's choice section, the editor clicked on the validate button
  GcECD.saveECD = function(ecd) {
    if (ecd.new_mode) {
      GcECD.addECD(ecd);
    } else if (ecd.edit_mode) {
      GcECD.updateECD(ecd);
    }
    mixpanel.track('ecd:saved');
  };

  // This is a new ECD, send it to the server
  GcECD.addECD = function(ecd) {
    ecd.new_mode = false;

    var cmts = [];

    ecd.comments.forEach(function(_cmt) {
      _cmt.user_picture = _cmt.cached_author.picture || '/images/avatar_3.png';
      cmts.push({
        user_picture : _cmt.user_picture,
        comment : _cmt._id
      });
    });

    CommentService.ECD.pushECD(ecd.title, cmts);

    $rootScope.$broadcast('editorial', {
      activate : false
    });
    $rootScope.ecd_creation_mode = false;
  };

  // This is a existing ECD, update it
  GcECD.updateECD = function(ecd) {
    ecd.edit_mode = false;

    if (ecd.old_title === ecd.title) {
      return;
    }

    CommentService.ECD.updateECD(ecd._id, ecd.title, function(_ecd) {
      console.log(_ecd);
    });
  };

  // In the Editor's choice section, the editor clicked on the cancel button
  GcECD.deleteECD = function(ecd) {
    if (ecd.new_mode) {
      CommentService.ecd.pop();

      $rootScope.$broadcast('editorial', {
        activate : false
      });
      $rootScope.ecd_creation_mode = false;

    } else if (ecd.edit_mode) {
      $translate('ecd delete confirm').then(function(msg) {
        if (confirm(msg) ) { // jshint ignore:line
          CommentService.ECD.deleteECD(ecd._id, function () {
            CommentService.ecd = CommentService.ecd.filter(function (choice) {
              return choice._id !== ecd._id;
            });
          });
          mixpanel.track('ecd:deleted');
        }
      });
    }
  };

  return GcECD;
}]);
